import { ffxHostUxIcons } from '../iconSets';
import { initializeIconSet } from '../initializeIconSet';
import { ffxHostUxIconName } from '../IconNames';

/**
 * Type-safe access of the icon names of this set, with the registration of the iconSet as a side effect
 *
 * @param name property name of componentsIcons
 */
export const useFFXHostUxIcon = ffxHostUxIconName;

/**
 * Side effect to register the icon set when this file is referenced, such as when the type-safe functions are used
 */
initializeIconSet(ffxHostUxIcons);
